module.exports = __webpack_public_path__ + "img/vietnam.cece51db.svg";